"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAssetVerificationQueryParams = void 0;
const createAssetVerificationQueryParams = ({ postgresQuery, }) => {
    const { parameterConfig } = postgresQuery;
    return {
        isValid: true,
        params: {
            statuses: parameterConfig.statusFilter.statuses,
        },
    };
};
exports.createAssetVerificationQueryParams = createAssetVerificationQueryParams;
//# sourceMappingURL=assetVerificationQueryParams.js.map